import React, { Fragment } from 'react';

import { Flex } from '../../../components/Flex';
import { SignupMethod } from '../../../model/user/types/SignupMethod';
import { useAppSelector } from '../../../redux/store';
import { userSliceSelectors } from '../../../redux/user/user.selector';
import { SettingsAccountDeletion } from '../components/SettingsAccountDeletion';
import { SettingsPasswordChange } from '../components/change-password/SettingsPasswordChange';
import { SettingsEmailChange } from '../components/email-change/SettingsEmailChange';

export const SettingsGeneral: React.FC = () => {
  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;

  return (
    <Flex flexDirection="column" gap="m">
      {user.signupMethod === SignupMethod.EMAIL ? (
        <Fragment>
          <SettingsEmailChange />

          <SettingsPasswordChange />
        </Fragment>
      ) : null}

      <SettingsAccountDeletion />
    </Flex>
  );
};
